module.exports = __webpack_public_path__ + "img/01.1b233cb8.jpg";